import { createReducer, on } from '@ngrx/store';
import { initialLocationsState, ILocationsState } from './locations.state';
import {  AddLocationError, AddLocationSuccess, DeleteLocationError, DeleteLocationSuccess, LocationsLoaded, UpdateLocationError, UpdateLocationSuccess } from './locations.actions';

export const initialState: ILocationsState = {
  locations: [],

};

const setLocations = (state: ILocationsState, { locations }: { locations: any[] }) => ({
  ...state,
  locations: locations 
});

const _locationsReducer = createReducer<ILocationsState>(
  initialLocationsState,
  on(LocationsLoaded, setLocations),
  on(AddLocationSuccess, (state, { location }) => ({
    ...state,
    locations: [...state.locations, location],
    
  })),
  on(UpdateLocationSuccess, (state, { location }) => ({
    ...state,
    locations: state.locations.map(loc =>
      loc.id === location.id ? location : loc
    ),
    
  })),
  on(DeleteLocationSuccess, (state, { id }) => ({
    ...state,
    locations: state.locations.filter(loc => loc.id !== id),

  })),
  
);

export function locationsReducer(state: ILocationsState, action): ILocationsState {
  return _locationsReducer(state, action);
}
